import React, { useState } from "react";
import "moment/locale/pt-br.js";
import Filtro from "./Filtro";
import Table from "./Table";
import ReportAcordeon from "../../../Components/ReportAcordeon";
import {
  getEnrollmentsReport,
  getDownloadReport,
  postDownloadReport,
} from "../../../../../services/NexiDigitalAPI";

const EnrollmentsReport = ({ index, expanded: _expanded }) => {
  const idReport = 7;
  const name = "Relatório Matrículas";
  const description = "Detalhes sobre relatório de matrículas.";
  const [expanded, setExpanded] = useState(_expanded);

  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [requestFilters, setRequestFilters] = useState({});

  const onClickExpanded = (value) => {
    setExpanded(value);
  };

  const actionFilter = async (values) => {
    if (expanded) {
      setLoading(true);

      const filter = { ...requestFilters, ...values };

      if (!filter.startDate || !filter.finishDate) {
        setLoading(false);
        return;
      }

      setRequestFilters(filter);

      getEnrollmentsReport(filter)
        .then((response) => {
          const responseData = response.data;
          setTotalRecords(responseData.totalRecords);
          setDados(responseData.result);
        })
        .finally(() => setLoading(false));
    }
  };

  const downloadEvent = async (values) => {
    if (loading) return;

    setLoading(true);

    const filter = { ...requestFilters, ...values };
    const { startDate, finishDate, idCompany, nodeCode, idTeam, userStatus, idUser } = filter;

    await postDownloadReport(idReport, {
      startDate,
      finishDate,
      idCompany,
      nodeCode,
      idTeam,
      userStatus,
      idUser,
    });
    await requestDownloadReport();
  };

  const requestDownloadReport = async () => {
    const response = await getDownloadReport(idReport);
    const { status, fileUrl } = response?.data || {};

    if (status === "Waiting") {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      return requestDownloadReport();
    }

    if (status === "Done" && fileUrl) {
      getFileReport(fileUrl);
      setLoading(false);
    }
  };

  const getFileReport = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.click();
  };

  const filter = (
    <Filtro
      actionFilter={actionFilter}
      loading={loading}
      expanded={expanded}
      downloadEvent={downloadEvent}
      dados={dados}
    />
  );

  const result = (
    <Table
      dados={dados}
      loading={loading}
      actionFilter={actionFilter}
      totalRecords={totalRecords}
    />
  );

  return (
    <ReportAcordeon
      onClickExpanded={onClickExpanded}
      name={name}
      description={description}
      filter={filter}
      result={result}
      index={index}
      expanded={expanded}
    />
  );
};

export default EnrollmentsReport;
